import { useLayoutEffect, useRef, useState } from 'react';
import './ExpandableDescription.css';

type ExpandableDescriptionProps = {
    text: string;
    className?: string;
};

const ExpandableDescription = ({ text, className = '' }: ExpandableDescriptionProps) => {
    const [expanded, setExpanded] = useState(false);
    const [needsToggle, setNeedsToggle] = useState(false);
    const textRef = useRef<HTMLParagraphElement>(null);

    useLayoutEffect(() => {
        setExpanded(false);
        setNeedsToggle(false);
    }, [text]);

    useLayoutEffect(() => {
        if (expanded) return;
        const el = textRef.current;
        if (!el) return;
        setNeedsToggle(el.scrollHeight - el.clientHeight > 2);
    }, [text, expanded]);

    return (
        <div className={`expandable-description mt-1 ${className}`.trim()}>
            <p ref={textRef} className={`expandable-description-text mb-0${expanded ? ' is-expanded' : ''}`}>
                {text}
            </p>
            {needsToggle && (
                <button
                    type="button"
                    className="btn btn-link p-0 align-baseline font-12 text-decoration-none"
                    onClick={() => setExpanded((v) => !v)}>
                    {expanded ? 'Read less' : 'Read more'}
                </button>
            )}
        </div>
    );
};

export default ExpandableDescription;
